/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

export class MediauploadForm {
  public image: String;
  public path: string;
  public fileName: string;

  constructor(mediaupload: any) {
    this.image = mediaupload.imageName || '';
    this.path = mediaupload.path || '';
    this.fileName = mediaupload.fileName || '';
  }
}
